import React from "react";
import useProductName from "brand-customization/useProductName";
import useResourceCustomization from "brand-customization/useResourceCustomization";
import { Trans, useTranslation } from "react-i18next";
import { Button, Panel } from "components/bootstrap";
const InstallForwarderStep = ({ eventKey, onStepComplete }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const productName = useProductName();
  const { url } = useResourceCustomization("forwarder_download_url");
  return /* @__PURE__ */ React.createElement(Panel, { eventKey }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Panel.Title, null, /* @__PURE__ */ React.createElement(Panel.Toggle, { tabIndex: 0 }, t("install_forwarder.heading")))), /* @__PURE__ */ React.createElement(Panel.Body, { collapsible: true }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "install_forwarder.intro",
      values: { productName },
      components: {
        forwarderLink: /* @__PURE__ */ React.createElement("a", { href: url, target: "_blank", rel: "noopener noreferrer" }, productName)
      }
    }
  )), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "small", onClick: onStepComplete }, t("start_new_common.continue"))));
};
export default InstallForwarderStep;
